// This icon file is generated automatically.
var DashOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z" } }] }, "name": "dash", "theme": "outlined" };
export default DashOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DashOutlined.js
// module id = 2364
// module chunks = 0